<template>
  <div class="current-level">
    <Header />
    <div class="level-main">
      <div class="title">Current level</div>

      <div class="levles">
        <div class="levle-item" v-for="(item, index) in levleList" :key="index">
          <Level :LevelData="item"></Level>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import Level from "./mycom/level.vue";
let credit = 0;
if (localStorage.getItem("accountInfo")) {
  credit = JSON.parse(localStorage.getItem("accountInfo")).credit;
}
export default {
  components: { Header, Footer, Level },
  data() {
    return {
      levleList: [
        {
          imgUrl: require("@/assets/pcImg/other/lv1.png"),
          superscript: credit > 60 ? 60 : credit,
          subscript: 60,
        },
        {
          imgUrl: require("@/assets/pcImg/other/lv2.png"),
          superscript: credit > 100 ? 100 : credit,
          subscript: 100,
        },
        {
          imgUrl: require("@/assets/pcImg/other/lv3.png"),
          superscript: credit > 200 ? 200 : credit,
          subscript: 200,
        },
        {
          imgUrl: require("@/assets/pcImg/other/lv4.png"),
          superscript: credit > 500 ? 500 : credit,
          subscript: 500,
        },
        {
          imgUrl: require("@/assets/pcImg/other/lv5.png"),
          superscript: credit > 800 ? 800 : credit,
          subscript: 800,
        },
        {
          imgUrl: require("@/assets/pcImg/other/lv6.png"),
          superscript: credit > 1000 ? 1000 : credit,
          subscript: 1000,
        },
      ],
    };
  },
};
</script>
<style scoped>
.current-level {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.level-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
}
.level-main > .title {
  font-size: 17.5px;
  font-weight: bold;
}
.levle-item {
  width: 184.375px;
  height: 131.25px;
  margin-right: calc((100% - 553.125px) / 2);
  margin-top: 20px;
}
.levle-item:nth-of-type(3n) {
  margin-right: 0;
}
.levles {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/currentLevel.vue